import './App.css';
import Card from './components/Card/Card';
function App() {
  return (
    <div className="App">
      <h1><b>The Card Effect</b></h1>
        <div class="container">
          <h2 class="text-center text-dark mt-4">HIGHLIGHTS</h2>
        </div>
          <div>
            <Card/>
          </div>
    </div>
  );
}

export default App;
